var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"sr-only"},[_vm._v("Mapa")]),_c('div',{directives:[{name:"wms-resource",rawName:"v-wms-resource:text",value:('embedGoogleMaps'),expression:"'embedGoogleMaps'",arg:"text"}],staticClass:"maps"})])}
var staticRenderFns = []

export { render, staticRenderFns }